import { render, staticRenderFns } from "./DonutChartV2.vue?vue&type=template&id=c0980e56&scoped=true"
import script from "./DonutChartV2.vue?vue&type=script&lang=js"
export * from "./DonutChartV2.vue?vue&type=script&lang=js"
import style0 from "./DonutChartV2.vue?vue&type=style&index=0&id=c0980e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0980e56",
  null
  
)

export default component.exports